export const BX_DESCKTOP_MAIN_PAGE = 'aud_desktop_bx206_search_string_desktop';

export const EXPERIMENTS: string[] = [BX_DESCKTOP_MAIN_PAGE];
